const StringConstants = {
    // http method types
    GET: 'get',
    PUT: 'put',
    POST: 'post',
    DELETE: 'delete',

    // for MUI and zrm-utils-js
    ZILLOW_BRAND: 'zillow',

    // Proxy paths for APIs
    PROXY_PATH: 'rental-manager/growth/proxy/',
    RG_PROXY_PATH: 'rental-manager/growth/growth-proxy/',

    // links
    ZILLOW_URL: 'https://www.zillow.com',
    ZILLOW_LIST_HOME_FOR_RENT: 'https://www.zillow.com/rental-manager/properties?postingPath=true',
    ZILLOW_PRICE_MY_RENTAL_PATH: 'https://www.zillow.com/rental-manager/price-my-rental/',

    // strings
    ZILLOW_ERROR_COPY: 'Return to the Price My Rental tool',

    // Sonar test constants
    PMR_SERVICE_NAME: 'rental-growth-web',
    PMR_BASE_URL: 'https://www.zillow.com/rental-manager/price-my-rental/',
    MARKET_TRENDS_BASE_URL: 'https://www.zillow.com/rental-manager/market-trends/',

    SONAR_SOURCE_RESPONSE_STATUS: 'RESPONSE_STATUS',
    SONAR_SOURCE_RESPONSE_TEXT: 'RESPONSE_TEXT',

    SONAR_COMPARISON_EQUAL: 'EQUAL',
    SONAR_COMPARISON_CONTAINS: 'CONTAINS',
    SONAR_COMPARISON_DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',

    SONAR_VALUE_STATUS_CODE_200: '200'
};

export default StringConstants;
